import { Heading, Text, buttonVariants } from "@/design-system";
import { cn } from "@/utils";
import { Mail } from "lucide-react";
import { COMPANY, DPO } from "../content/company";

/**
 * O canal do titular: nome e e-mail do encarregado, à vista em todo documento
 * (LGPD, art. 41, §1º; Resolução CD/ANPD nº 18/2024), mais a identificação da
 * empresa (art. 9º, III).
 */
export const LegalContactCard = () => (
  <section
    aria-labelledby="encarregado-title"
    className="rounded-ds-xl bg-ds-ink-900 flex flex-col gap-6 p-6 sm:p-10 md:flex-row md:items-end md:justify-between"
  >
    <div className="flex max-w-xl flex-col gap-3">
      <Text as="p" size="small" weight="semibold" className="text-ds-brand-300">
        Encarregado de dados (DPO)
      </Text>
      <Heading level={2} id="encarregado-title" className="text-ds-on-solid">
        Dúvida sobre seus dados? Fale com {DPO.name}
      </Heading>
      <Text className="text-ds-ink-200">
        Respondemos pedidos de titulares em até 15 dias. Se o pedido for sobre
        dados que uma loja cadastrou, avisamos a loja e acompanhamos a resposta.
      </Text>
      <Text as="p" size="small" className="text-ds-ink-300">
        {COMPANY.legalName} · CNPJ {COMPANY.cnpj} · {COMPANY.address}
      </Text>
    </div>
    <a
      href={`mailto:${DPO.email}`}
      className={cn(
        buttonVariants({ variant: "primary", size: "md", fullWidth: false }),
        "focus-visible:ring-offset-ds-ink-900 shrink-0 break-all"
      )}
    >
      <Mail aria-hidden="true" className="size-5 shrink-0" />
      {DPO.email}
    </a>
  </section>
);
